import React from 'react'
import PropTypes from 'prop-types'
import Transition from 'react-transition-group/Transition'
import { cx } from '@emotion/css'
import CloseIcon from '@offerzen/zenicon/CloseIcon'
import { colors } from '../../themes'
import AccessibleIcon from '../AccessibleIcon'
import styles, { wrapperTransition, containerSize, containerTransition } from './styles'
import LockScroll from '../LockScroll'

const Modal = ({ children, className, onModalClose, visible, preventClose, hideModal, size = 'default' }) => {
  const handleHideModal = () => {
    if (!preventClose) hideModal()
  }

  return (
    <Transition in={visible} timeout={{ enter: 0, exit: 300 }} mountOnEnter unmountOnExit onExited={onModalClose}>
      {status => (
        <div className={cx(styles.wrapper, className, wrapperTransition(status))}>
          {/* eslint-disable-next-line jsx-a11y/click-events-have-key-events, jsx-a11y/no-static-element-interactions */}
          <div className={styles.overlay} onClick={handleHideModal} />

          <div className={cx(styles.container, containerSize(size), containerTransition(status))}>
            <button type="button" className={styles.icon} onClick={handleHideModal}>
              <AccessibleIcon icon={CloseIcon} color={colors.grayChateau} size={20} />
              <span className={styles.accessiblyHidden}>Close</span>
            </button>

            {Boolean(children) && <LockScroll locked={visible}>{children({ hideModal: handleHideModal })}</LockScroll>}
          </div>
        </div>
      )}
    </Transition>
  )
}

Modal.propTypes = {
  size: PropTypes.oneOf(['', 'default', 'small', 'medium', 'large']),
  onModalClose: PropTypes.func,
  preventClose: PropTypes.bool,
  children: PropTypes.func.isRequired,
  className: PropTypes.string,
  visible: PropTypes.bool.isRequired,
  hideModal: PropTypes.func.isRequired,
}

export default Modal
